import { FC } from "react";
import styles from "./ReferalProgressBar.module.scss";
import { Ticket, TicketType } from "../../TicketsPanel/Ticket";
import fragmentIcon from "../../../icons/fragment.png";

interface IReferalProgressBarProps {
    milestones: number[];
    type: 'tickets' | 'fragments'
}

export const ReferalProgressBar: FC<IReferalProgressBarProps> = ({ milestones, type }) => {
    const getIcon = () => {
        switch (type) {
            case 'tickets':
                return <Ticket type={'epicTickets' as TicketType} value={ 0 } hideValue={ true } />;

            case 'fragments':
                return <img className={ styles.fragmentImage} src={ fragmentIcon } alt='fragment' />;
        }
    }
    
    return (
        <div className={styles.cont}>
            <span>{ getIcon() }</span>
            
            {milestones.map((milestone, index) => (
                <span className={styles.valueLabel} key={`ticket${index}`}>
                    { milestone ? `${milestone} шт` : '' }
                </span>
            ))}
        </div>
    );
}